import { render, staticRenderFns } from "./eliminar_agrupados.vue?vue&type=template&id=a71c8382"
import script from "./eliminar_agrupados.vue?vue&type=script&lang=js"
export * from "./eliminar_agrupados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports